export default __webpack_public_path__ + "static/media/02c_fold-9.7c1b6434.mp4";